'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoHeartBroken = function IoHeartBroken(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.6 22.5c0 2.8-0.1 5.5 0.4 8.4 0.1 0.7 0.1 1.5 0.1 2.4l-11.9-12.4c-3.6-3.7-3.6-9.7 0-13.4 3.1-3.2 8-3.4 11.2-0.2-0.1 1.1-0.2 2.4-0.2 3.6-1.4 1.1-3.2 1.6-4.4 3l0.9-0.5c1.3-0.9 1.1-0.7 2.7-1.1 0.2-0.1 0.6-0.3 0.9-0.4 0 0.1-0.1 0.4-0.1 0.4 0.1 1.6 0.8 3.1 1.1 4.7 0 0.4 0.1 0.8 0 1.2-0.7 1.3-0.6 2.9-0.7 4.3z m7.3 1c0.6 1.4 1.8 2.3 3 3.1l-8.1 8.4-1.4-1.4c0-1-0.3-2-0.3-3-0.1-3.7 0.8-7.3 1.6-11.1 0.1 0.1 0.2 0.1 0.3 0.1 2.3 0.5 4 1.9 4.9 3.9z m8.4-16c3.6 3.7 3.6 9.7 0 13.4l-5.3 5.4c-2.2-1.8-3.2-4.2-5-6.3-1-1-2.1-1.8-3.2-2.5-0.3-1-0.7-2-0.9-3-0.2-1 1.1-1.7 1.2-2.5 0.3-0.9 0.3-2 0.3-3l1.5-1.5c3.1-3.3 8.3-3.3 11.4 0z' })
        )
    );
};

exports.default = IoHeartBroken;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/heart-broken.js
// module id = 2071
// module chunks = 0